import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../components/Header.js';
import MasonryGrid from '../components/Utils/MasonryGrid.js';

let image_path = "/images/art/";
let images = [
    { "image": "implicate_order.jpg", "description": "" },
    { "image": "fractals.jpg", "description": "" },
    { "image": "figure3.jpg", "description": "" },
    { "image": "figure11.jpg", "description": "" },
    { "image": "figure4.jpg", "description": "" },
    { "image": "butterfly.jpg", "description": "" },
    { "image": "figure2.jpg", "description": "" },
    { "image": "figure8.jpg", "description": "" },
    { "image": "figure7.jpg", "description": "" },
    { "image": "figure9.jpg", "description": "" },
    { "image": "figure10.jpg", "description": "" },
    { "image": "figure1.jpg", "description": "" },
    { "image": "figure6.jpg", "description": "" },
    { "image": "figure5.jpg", "description": "" },
    { "image": "paper_figure.jpg", "description": "" },
    { "image": "astronaut_side.jpg", "description": "" },
    { "image": "astronaut_front.jpg", "description": "" }
];
class Gallery extends Component {
    constructor(props) {
        super(props);
        this.galleryRef = React.createRef();
        this.state = {
            width: 0,
            height: 0
        };
        //console.log('1. Gallery Props');
    }

    componentDidMount() {
        //console.log('6. Gallery Component Did Mount');
        this.resizeObserver = new ResizeObserver((entries) => {
            const { inlineSize, blockSize } = entries[0].contentBoxSize[0];
            this.setState({
                width: inlineSize,
                height: blockSize
            });
        });
        this.resizeObserver.observe(this.galleryRef.current);
    }

    onGridComplete = (masonryData) => {
        //console.log('11. Gallery onGridComplete');
        if (masonryData === undefined || masonryData.width === 0 || masonryData.height === 0) return;
        if (masonryData.height !== this.state.height) {
            //console.log('12. Gallery onGridComplete - adjusting gallery ref height - final step!')
            this.galleryRef.current.style.height = `${masonryData.height}px`;
        }
    }

    componentWillUnmount() {
        // Disconnect the resize observer to clean up
        this.resizeObserver.disconnect();
    }
    render() {
        const { width, height } = this.state;
        return (
            <div id="page">
                <Header />
                <div id="body">
                    <div className="private-gallery-header">
                        <h1>Art Gallery</h1>
                        <p>As a lifelong artist, I am always creating. These peieces are from my own personal gallery.</p>
                    </div>
                    <div className="gallery-container private-gallery" ref={this.galleryRef}>
                        <MasonryGrid image_path={image_path} images={images} width={width} height={height} onGridComplete={this.onGridComplete} />
                    </div>
                    <div id="gallery" className="personal_gallery more-stuff-page">
                    </div>
                </div>
            </div>
        );
    }
}

export default Gallery;